<template>
  <div class="activity">
    <object id="game" title="game" :data="this.$route.params.url"></object>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "gameDetail",

  data() {
    return {
      active: true,
    };
  },

  mounted() {
    console.log(this.$route.params.url);
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.activity {
  object {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
  }
}
</style>
